import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { mapLocaleToMomentjsLocale } from '../../i18n/mmu-translate-handler';

@Pipe({ name: 'humanizeDuration' })
export class MmuHumanizeDurationPipe implements PipeTransform {
  private localMoment = moment;

  constructor(@Inject(LOCALE_ID) private locale: string) {
    const language = mapLocaleToMomentjsLocale(locale);
    this.localMoment.locale(language);
  }

  transform(value: string, rounding?: string): string {
    const d = this.localMoment.duration(value);

    const roundingDefault = this.localMoment.relativeTimeRounding();
    if (rounding === 'floor') {
      this.localMoment.relativeTimeRounding(Math.floor);
    }

    const humanized = d.humanize();
    this.localMoment.relativeTimeRounding(roundingDefault);
    return humanized;
  }
}
